var _mask, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDarkOnline(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "path-1-inside-1_864_2398",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 9C0 4.02944 4.02944 0 9 0C13.9706 0 18 4.02944 18 9C18 13.9706 13.9706 18 9 18C4.02944 18 0 13.9706 0 9Z"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 9C0 4.02944 4.02944 0 9 0C13.9706 0 18 4.02944 18 9C18 13.9706 13.9706 18 9 18C4.02944 18 0 13.9706 0 9Z",
    fill: "#3FDD78"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9 14C6.23858 14 4 11.7614 4 9H-4C-4 16.1797 1.8203 22 9 22V14ZM14 9C14 11.7614 11.7614 14 9 14V22C16.1797 22 22 16.1797 22 9H14ZM9 4C11.7614 4 14 6.23858 14 9H22C22 1.8203 16.1797 -4 9 -4V4ZM9 -4C1.8203 -4 -4 1.8203 -4 9H4C4 6.23858 6.23858 4 9 4V-4Z",
    fill: "#232627",
    mask: "url(#path-1-inside-1_864_2398)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDarkOnline);
export default __webpack_public_path__ + "static/media/dark_online.7c2ced0a2917f24d279a982e75b1aa70.svg";
export { ForwardRef as ReactComponent };